import { BooleanField, TextField } from "react-admin";

import BulkActions from "./BulkActions";
import Card from "./Card";
import DurationField from "./fields/DurationField";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import LastResultField from "./fields/LastResultField";
import NameField from "./fields/NameField";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import StatusField from "./fields/StatusField";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { "cron-job": highlightedCronJobIds = [] } = useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedCronJobIds.includes(id)) return "modifyResource";
    return "";
  };
  return (
    <ResponsiveList
      {...props}
      type="table"
      sort={{ field: "last_run", order: "DESC" }}
      split
      filters={<Filters />}
      bulkActionButtons={<BulkActions />}
      perPage={10}
      key={highlightedCronJobIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="cron-job"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <BooleanField source="is_enabled" />
        <NameField source="name" />
        <StatusField source="status" />
        <LastResultField source="last_result" />
        <DurationField source="last_run" />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};

export default List;
